import React, { useState, useEffect, Fragment } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    InputGroup,
    Badge,
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons';
import IntlMessages from '../../../../../helpers/IntlMessages';
export default function TestIntegrationBookingUrl({ visible, selectedTokens, inputData, inputUrl, ChangeAgeDil }) {
    // Helper function to convert moment format to DatePicker format
    // const convertDateFormat = (format) => {
    //     if (!format) return "yyyy-MM-dd";
    //     return format.toLowerCase()
    //         .replace(/YYYY/g, 'yyyy')
    //         .replace(/DD/g, 'dd')
    //         .replace(/MM/g, 'mm');
    // };
    const convertDateFormat = (format) => {
        if (!format) return "MM/dd/yyyy"; // for DatePicker
        return format
            .replace(/YYYY/g, 'yyyy')
            .replace(/DD/g, 'dd')
            .replace(/MM/g, 'MM');
    };
    const [testInputs, setTestInputs] = useState({
        checkinDate: "",
        checkoutDate: "",
        adult: "0",
        children: "0",
        roomType: "",
        promoCode: "",
        source: "",
        language: "",
        currency: "",
        nights: "",
        children_age: [],
        childrenAgeDelimiter: "-"
    });
    const [childrenAgeInput, setChildrenAgeInput] = useState([]);
    const [bookingUrl, setBookingUrl] = useState("");
    const [dateFormat, setDateFormat] = useState("");
    const [checkInDate, setCheckInDate] = useState(moment().add(1, "day"));
    const [checkOutDate, setCheckOutDate] = useState(moment().add(2, "day"));
    const [bookingUrlText, setBookingUrlText] = useState("");
    const [urlcopied, setUrlCopied] = useState(false);
    useEffect(() => {
        if (inputData !== undefined && inputData.dateFormat) {
            const dateFormat = inputData.dateFormat || "YYYY-MM-DD";
            // Ensure dates are valid before formatting
            if (!checkInDate.isValid() || !checkOutDate.isValid()) {
                console.error('Invalid dates in useEffect');
                return;
            }
            const checkInFormatted = checkInDate.format("YYYY-MM-DD");
            const checkOutFormatted = checkOutDate.format("YYYY-MM-DD");
            let night = calculateNights(checkInFormatted, checkOutFormatted);
            let childAge = "";
            let childrenAge = testInputs.children_age;
            if (childrenAge.length > 0) {
                childrenAge.map((item, index) => {
                    childAge += item["children_age_" + (index + 1)];
                    if (item["children_age_" + (index + 1)] !== "" && childAge !== "" && childrenAge.length > (index + 1)) {
                        childAge += inputData.childrenAgeDelimiter;
                    }
                })
            }
            setTestInputs({
                ...testInputs,
                checkinDate: checkInFormatted,
                checkoutDate: checkOutFormatted,
                nights: night,
                childrenAgeDelimiter: inputData.childrenAgeDelimiter
            });
            let bookingurl = inputUrl;
            if (testInputs.children === "0") {
                if (inputUrl.includes("{ADULTS}-{CHILDREN_AGE}")) {
                    bookingurl = bookingurl.replace("{ADULTS}-{CHILDREN_AGE}", "{ADULTS}{CHILDREN_AGE}")
                }
            }
            setBookingUrl(bookingurl);
            setDateFormat(dateFormat);
            var repchildage = childAge;
            repchildage = childAge.replaceAll("-", inputData.childrenAgeDelimiter);
            setBookingUrlText(bookingurl
                .replace("{CHECK_IN}", checkInFormatted)
                .replace("{CHECK_OUT}", checkOutFormatted)
                .replace("{ADULTS}", testInputs.adult)
                .replace("{CHILDREN}", testInputs.children)
                .replace("{ROOM_TYPE}", testInputs.roomType)
                .replace("{PROMO_CODE}", testInputs.promoCode)
                .replace("{SOURCE}", testInputs.source)
                .replace("{LANGUAGE}", testInputs.language)
                .replace("{CURRENCY}", testInputs.currency)
                .replace("{NIGHTS}", night)
                .replace("{CHILDREN_AGE}", repchildage));
        }
    }, [inputData])
    const urlReplace = (name, value, childrenage_arr) => {
        let childAge = "";

        let childrenAge = name === "children_age" ? value : childrenage_arr === undefined ? testInputs.children_age : childrenage_arr;

        if (childrenAge.length > 0) {
            childrenAge.map((item, index) => {
                childAge += item["children_age_" + (index + 1)];
                if (item["children_age_" + (index + 1)] !== "" && childAge !== "" && childrenAge.length > (index + 1)) {
                    childAge += testInputs.childrenAgeDelimiter
                }
            })
        }
        let night = calculateNights(name === "checkinDate" ? value : testInputs.checkinDate, name === "checkoutDate" ? value : testInputs.checkoutDate);

        var repchildage = childAge;
        if (name === "age_delimiter") {
            repchildage = childAge.replaceAll("-", value);
        }
        setBookingUrlText(bookingUrl.replace("{CHECK_IN}", name === "checkinDate" ? value : testInputs.checkinDate)
            .replace("{CHECK_OUT}", name === "checkoutDate" ? value : testInputs.checkoutDate)
            .replace("{ADULTS}", name === "adult" ? value : testInputs.adult)
            .replace("{CHILDREN}", name === "children" ? value : testInputs.children)
            .replace("{ROOM_TYPE}", name === "roomType" ? value : testInputs.roomType)
            .replace("{PROMO_CODE}", name === "promoCode" ? value : testInputs.promoCode)
            .replace("{SOURCE}", name === "source" ? value : testInputs.source)
            .replace("{LANGUAGE}", name === "language" ? value : testInputs.language)
            .replace("{CURRENCY}", name === "currency" ? value : testInputs.currency)
            .replace("{NIGHTS}", night)
            .replace("{CHILDREN_AGE}", repchildage));
    }
    const handleCheckinDateChange = date => {
        if (!date || !moment.isMoment(date) || !date.isValid()) {
            console.error('Invalid check-in date provided');
            return;
        }
        setCheckInDate(date);
        const format = dateFormat || "YYYY-MM-DD";
        // const formattedDate = date.format(format);
        const formattedDate = date.format("YYYY-MM-DD");
        let night = calculateNights(formattedDate, testInputs.checkoutDate);
        setTestInputs({ ...testInputs, checkinDate: formattedDate, nights: night });
        urlReplace("checkinDate", formattedDate);
    };
    const handleCheckOutDateChange = date => {
        if (!date || !moment.isMoment(date) || !date.isValid()) {
            console.error('Invalid check-out date provided');
            return;
        }
        setCheckOutDate(date);
        const format = dateFormat || "YYYY-MM-DD";
        // const formattedDate = date.format(format);
        const formattedDate = date.format("YYYY-MM-DD");
        let night = calculateNights(testInputs.checkinDate, formattedDate);
        setTestInputs({ ...testInputs, checkoutDate: formattedDate, nights: night });
        urlReplace("checkoutDate", formattedDate);
    };
    const calculateNights = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        let dayCount = 0
        while (end > start) {
            dayCount++
            start.setDate(start.getDate() + 1)
        }
        return dayCount
    };
    const handleChange = e => {
        if (e.target.name === "children" && bookingUrl.includes("{CHILDREN_AGE}")) {
            let childrenValue = parseInt(e.target.value);
            let childrenAge = [...childrenAgeInput];
            if (childrenAge.length > childrenValue) {
                let arr = [];
                for (var i = 0; i < childrenValue; i++) {
                    arr.push(childrenAgeInput[i]);
                }
                childrenAge = arr;
            }
            else {
                for (var i = childrenAgeInput.length; i < childrenValue; i++) {
                    childrenAge.push({
                        id: i + 1,
                        ["children_age_" + (i + 1)]: ""
                    })
                }
            }
            setChildrenAgeInput(childrenAge);
            setTestInputs({ ...testInputs, [e.target.name]: e.target.value, children_age: childrenAge });
            urlReplace(e.target.name, e.target.value, childrenAge);
        }
        else {
            setTestInputs({ ...testInputs, [e.target.name]: e.target.value });
            urlReplace(e.target.name, e.target.value);
        }
    };
    const handleChangeChildrenAge = (e, id) => {
        let childrenAge = [...childrenAgeInput];
        childrenAge = childrenAgeInput.map((item) => {
            if (item.id === id) {
                return { ...item, [e.target.name]: e.target.value };
            }
            else {
                return { ...item }
            }
        });
        setChildrenAgeInput(childrenAge);
        urlReplace("children_age", childrenAge);
        setTestInputs({ ...testInputs, children_age: childrenAge });
    }
    const handleDelimiterChange = (e) => {
        setTestInputs({ ...testInputs, childrenAgeDelimiter: e.target.value });
        if (e.target.value !== "") {
            urlReplace("age_delimiter", e.target.value);
            ChangeAgeDil(e.target.value);
        }

    }
    const openInNewTab = url => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    // Ensure dates are valid before rendering
    if (checkInDate && !checkInDate.isValid()) {
        console.error('Invalid checkInDate detected');
        return null;
    }
    if (checkOutDate && !checkOutDate.isValid()) {
        console.error('Invalid checkOutDate detected');
        return null;
    }

    return (
        <Fragment>
            {visible && (
                <Row>
                    {selectedTokens.map((item, i) => (
                        <Fragment key={i}>
                            {(item.value === "{CHECK_IN}" && item.value === "{CHECK_OUT}") || item.value === "{CHECK_IN}" ? (
                                <Fragment>
                                    <Colxx sm={3} className="mb-5">
                                        <label>Check In Date</label>
                                        <DatePicker
                                            dateFormat={convertDateFormat(dateFormat)}
                                            selected={checkInDate && checkInDate.isValid() ? checkInDate.toDate() : null}
                                            onChange={date => handleCheckinDateChange(moment(date))}
                                        />
                                    </Colxx>
                                    <Colxx sm={3} className="mb-5">
                                        <label>Check Out Date</label>
                                        <DatePicker
                                            dateFormat={convertDateFormat(dateFormat)}
                                            selected={checkOutDate && checkOutDate.isValid() ? checkOutDate.toDate() : null}
                                            onChange={date => handleCheckOutDateChange(moment(date))}
                                        />
                                    </Colxx>
                                </Fragment>
                            ) : ""}
                            {item.value === "{NIGHTS}" && (
                                <Colxx sm={3} className="mb-5">
                                    <label>Nights</label>
                                    <Input
                                        type="text"
                                        value={testInputs.nights}
                                        onChange={handleChange}
                                        name="nights"
                                        disabled
                                    >
                                    </Input>
                                </Colxx>
                            )}
                            {item.value === "{ADULTS}" && (
                                <Colxx sm={3} className="mb-5">
                                    <label>Adult</label>
                                    <Input
                                        type="select"
                                        name="adult"
                                        value={testInputs.adult}
                                        onChange={handleChange}
                                        placeholder="Adult"
                                    >
                                        <option value="0">Select Adults</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option></Input>
                                </Colxx>
                            )}
                            {item.value === "{CHILDREN}" ? (
                                <Fragment>
                                    <Colxx sm={3} className="mb-5">
                                        <label>Children</label>
                                        <Input
                                            type="select"
                                            name="children"
                                            value={testInputs.children}
                                            onChange={handleChange}
                                            placeholder="Children"
                                        >
                                            <option value="0">Select Children</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option></Input>

                                    </Colxx>
                                </Fragment>
                            ) : ""}
                            {item.value === "{CHILDREN_AGE}" &&
                                <Fragment>
                                    {childrenAgeInput.map((element, index) => (
                                        <Colxx sm={3} key={index} className="mb-5">
                                            <label>Children Age ({index + 1})</label>
                                            <Input
                                                type="select"
                                                name={"children_age_" + (index + 1)}
                                                value={element[index]}
                                                onChange={(e) => handleChangeChildrenAge(e, element.id)}
                                                placeholder="Children Age"
                                            >
                                                <option value="0">Children Age</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                                <option value="15">15</option></Input>
                                        </Colxx>
                                    ))}

                                </Fragment>
                            }
                            {item.value === "{ROOM_TYPE}" && (
                                <Colxx sm={3} className="mb-5">
                                    <label><IntlMessages id='dashboards.room-type' /></label>
                                    <Input
                                        type="text"
                                        value={testInputs.roomType}
                                        onChange={handleChange}
                                        name="roomType"
                                    >
                                    </Input>
                                </Colxx>
                            )}
                            {item.value === "{PROMO_CODE}" && (
                                <Colxx sm={3} className="mb-5">
                                    <label>Promo Code</label>
                                    <Input
                                        type="text"
                                        name="promoCode"
                                        value={testInputs.promoCode}
                                        onChange={handleChange}
                                        placeholder="Promo Code"
                                    />
                                </Colxx>
                            )}
                            {item.value === "{SOURCE}" && (
                                <Colxx sm={3} className="mb-5">
                                    <label>Source</label>
                                    <Input
                                        type="text"
                                        name="source"
                                        value={testInputs.source}
                                        onChange={handleChange}
                                        placeholder="Source"
                                    />
                                </Colxx>
                            )}
                            {item.value === "{LANGUAGE}" && (
                                <Colxx sm={3} className="mb-5">
                                    <label>Language</label>
                                    <Input
                                        type="text"
                                        name="language"
                                        value={testInputs.language}
                                        onChange={handleChange}
                                        placeholder="Language"
                                    />
                                </Colxx>
                            )}
                            {item.value === "{CURRENCY}" && (
                                <Colxx sm={3} className="mb-5">
                                    <label>Currency</label>
                                    <Input
                                        type="text"
                                        name="currency"
                                        value={testInputs.currency}
                                        onChange={handleChange}
                                        placeholder="Currency"
                                    />
                                </Colxx>
                            )}
                        </Fragment>
                    ))}
                    <Colxx sm={12}>
                        <Fragment>
                            <span style={{ lineBreak: "anywhere" }}>{bookingUrlText}</span><br />
                            <Button
                                color="success"
                                size="xs"
                                onClick={() => openInNewTab(bookingUrlText)}
                            >
                                <i><FontAwesomeIcon icon={faExternalLinkAlt} /></i> Open Url</Button>
                        </Fragment>
                    </Colxx>
                </Row>
            )}
        </Fragment>
    )

};